import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import DataTable, { TableColumn } from "react-data-table-component";
import LayoutSubmaster from "../../components/layoutSubmasterConfig/layoutSubmaster"
import { Zip_Code_Api } from "../../services/zip_code_api/zip_code_api";
import { apiClientSubmaster } from "../../services/setupClientSubmaster/apiClientSubmaster";
import { toast } from "react-toastify";
import LocalStorage from "../../helpers/localstorage";
import axios from "axios";
import edit from '../../components/dashboard/img/favicon/editar.png';
import viewImg from '../../components/dashboard/img/favicon/galeria.png';

const MAX_EPI_DUE_DAYS = 1825;

type DataRow = {
    id: number;
    name?: string;
    epiName: string;
    epitype: string;
    expirationDate: string;
    epiinternalCode: string;
    epimanufacturerCode: string;
    quantity: number;
    average_price?: number | string | null;
    ca: string;
    minimumstock: number;
    activeepi: boolean;
    due_day: number;
};

type CompanyOption = {
    id: number;
    name: string;
    cnpj: string;
    image?: string;
};

type StockSummary = {
    id: number;
    description: string;
    observation?: string | null;
    is_default: boolean;
    company_name: string;
    company_cnpj: string;
    total_quantity: number;
};

type StockInventoryItem = {
    id: number;
    stock_quantity: number;
};

type EpiStockGroup = {
    stock: StockSummary;
    items: StockInventoryItem[];
};

type ModalImage = {
    id: number;
    url: string;
};

type PreviewImage = {
    file: File;
    url: string;
};

type MinimumStockConfirmationAction = "create" | "update";

type EpiCompanyAssociation = {
    id: number;
    epirecord_submaster_id: number;
    submaster_company_id: number;
    submaster_id: number;
    company_name?: string;
    company_cnpj?: string;
};

type EpiDeleteSummaryItem = {
    id: number;
    epiName: string;
    employeeNames: string[];
};

type EpiDeletePreviewPayload = {
    deletable: EpiDeleteSummaryItem[];
    blocked: EpiDeleteSummaryItem[];
    notFoundIds: number[];
};


function ConfigSubmasterEpiPage(){
    const localStorage = new LocalStorage()
    const canEpiCreate = localStorage.hasWebPermission("canEpiCreate");
    const canEpiEdit = localStorage.hasWebPermission("canEpiEdit");
    const canEpiDelete = localStorage.hasWebPermission("canEpiDelete");
    const submasterId = Number(localStorage.getId() ?? 0);

    const [formData, setFormData] = useState<{
        id: number;
        epiName: string;
        epitype: string;
        expirationDate: string; // timestamp (em milissegundos)
        epiinternalCode: string;
        epimanufacturerCode: string;
        quantity: number;
        average_price: number | string | null;
        ca: string;
        minimumstock:number;
        activeepi:boolean;
        due_day: number;
      }>({
        id:0,
        epiName: "",
        epitype: "",
        expirationDate: "", // ou 0 se quiser iniciar vazio
        epiinternalCode: "1",
        epimanufacturerCode: "1",
        quantity: 0,
        average_price: null,
        ca: "",
        minimumstock: 1,
        activeepi: true,
        due_day: 0
    });


    const resetData = () => {
        setFormData({
            id:0,
            epiName: "",
            epitype: "",
            expirationDate: "", 
            epiinternalCode: "1",
            epimanufacturerCode: "1",
            quantity: 0,
            average_price: null,
            ca: "",
            minimumstock: 1,
            activeepi: true,
            due_day: 0

        })
    }

    const marginFilter = { marginLeft: "-0.3%"};

    const formatCurrency = (value?: number | string | null) =>
        Number(value || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
        });

    const [showEmployeesFormUpdate ,setShowEmployeesFormUpdate ] = useState(false);
    const [getData, setgetData] = useState<DataRow[]>([]);
    const [showFormCreateEmployess ,setShowFormCreateEmployess] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [selectedEpis, setSelectedEpis] = useState<DataRow[]>([]);
    const [clearSelectedRows, setClearSelectedRows] = useState(false);
    const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
    const [minimumStockConfirmationAction, setMinimumStockConfirmationAction] =
        useState<MinimumStockConfirmationAction | null>(null);
    const [minimumStockConfirmationLoading, setMinimumStockConfirmationLoading] =
        useState(false);
    const [companies, setCompanies] = useState<CompanyOption[]>([]);
    const [stockControlEnabled, setStockControlEnabled] = useState(false);
    const [masterDataDeleteEnabled, setMasterDataDeleteEnabled] = useState(false);
    const [stockGroups, setStockGroups] = useState<EpiStockGroup[]>([]);
    const [stockGroupsLoading, setStockGroupsLoading] = useState(false);
    const [stockSelections, setStockSelections] = useState<Record<number, DataRow[]>>({});
    const [selectedCompanyId, setSelectedCompanyId] = useState(0);
    const [defaultCompany, setDefaultCompany] = useState<CompanyOption>({
        id: 0,
        name: String(localStorage.getName() ?? ""),
        cnpj: "",
        image: "",
    });

    const [idEpi, setidEpi] = useState(0);

    const [canDeleteImg, setcanDeleteImg] = useState(false);

  

    const getStorage = () => {
        const localStorage = new LocalStorage()
        return localStorage;
    }
    
   
      
    


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
      
        let formattedValue = value;
      
        if (name === 'cpf') {
          formattedValue = formatCpfCustom(value);
        }
      
        setFormData({
          ...formData,
          [name]: formattedValue,
        });
    };

    const formatCpfCustom = (value: string) => {
        return value
        .replace(/\D/g, '') // Remove tudo que não for número
        .replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1-$2-$3-$4'); // Aplica a máscara
    };

    const normalizeCompanies = (payload: any): CompanyOption[] => {
        const items = Array.isArray(payload)
            ? payload
            : Array.isArray(payload?.data)
                ? payload.data
                : Array.isArray(payload?.companies)
                    ? payload.companies
                    : payload?.data
                        ? [payload.data]
                        : [];

        return items.map((item: any) => ({
            id: Number(item?.id ?? item?.companyId ?? item?.company_id ?? item?.submaster_company_id ?? 0),
            name: String(
                item?.name_company ??
                item?.nameCompany ??
                item?.companyName ??
                item?.company_name ??
                item?.name ??
                ""
            ),
            cnpj: String(item?.cnpj ?? item?.CNPJ ?? item?.company_cnpj ?? item?.cnpj_company ?? ""),
            image: String(item?.image ?? item?.logo ?? item?.image_company ?? item?.submaster_logo_url ?? ""),
        })).filter((company: CompanyOption) => company.id > 0);
    };

    const getDefaultAssociatedCompany = () => companies[0] ?? (defaultCompany.id > 0 ? defaultCompany : null);

    const getDefaultCompanyName = () =>
        getDefaultAssociatedCompany()?.name?.trim() ||
        defaultCompany.name.trim() ||
        String(localStorage.getName() ?? "").trim() ||
        "Empresa padrão";

    const sortEpisAlphabetically = (rows: DataRow[]) =>
        [...rows].sort((firstEpi, secondEpi) =>
            firstEpi.epiName.localeCompare(secondEpi.epiName, "pt-BR", {
                sensitivity: "base",
                ignorePunctuation: true,
            })
        );

    const getSelectedCompanyPayload = () => {
        const selectedCompany = selectedCompanyId
            ? companies.find((company) => company.id === selectedCompanyId)
            : null;
        const company = selectedCompany ?? getDefaultAssociatedCompany();

        if (!company?.id) {
            return null;
        }

        return {
            submaster_company_id: company.id,
            company_name: company.name || getDefaultCompanyName(),
            company_cnpj: company.cnpj || "",
        };
    };

    const handleCompanyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedCompanyId(Number(e.target.value || 0));
    };

    const pluralizeEpi = (count: number) => (count === 1 ? "EPI" : "EPIs");

    const buildBlockedDeleteMessage = (blockedItems: EpiDeleteSummaryItem[]) =>
        blockedItems
            .map((item) => `${item.epiName} — ${item.employeeNames.join(", ")}`)
            .join("\n");

    const buildDeletePreviewMessage = (preview: EpiDeletePreviewPayload) => {
        const deletableLines = preview.deletable
            .map((item) => `- ${item.epiName}`)
            .join("\n");
        const blockedCount = preview.blocked.length;
        const blockedText =
            blockedCount > 0
                ? `\n\n${blockedCount} ${pluralizeEpi(blockedCount)} vinculad${blockedCount === 1 ? "o" : "os"} não ${blockedCount === 1 ? "será" : "serão"} removid${blockedCount === 1 ? "o" : "os"} nesta operação.`
                : "";

        return `Os itens abaixo serão excluídos permanentemente:\n\n${deletableLines}${blockedText}\n\nEsta ação não pode ser desfeita.\n\nDeseja continuar?`;
    };

    const normalizeEpiCompanyAssociations = (payload: any): EpiCompanyAssociation[] => {
        const items = Array.isArray(payload)
            ? payload
            : Array.isArray(payload?.data)
                ? payload.data
                : payload?.data
                    ? [payload.data]
                    : [];

        return items.map((item: any) => ({
            id: Number(item?.id ?? 0),
            epirecord_submaster_id: Number(item?.epirecord_submaster_id ?? item?.epirecordSubmasterId ?? 0),
            submaster_company_id: Number(item?.submaster_company_id ?? item?.submasterCompanyId ?? 0),
            submaster_id: Number(item?.submaster_id ?? item?.submasterId ?? 0),
            company_name: String(item?.company_name ?? item?.companyName ?? ""),
            company_cnpj: String(item?.company_cnpj ?? item?.companyCnpj ?? ""),
        })).filter((association: EpiCompanyAssociation) => association.id > 0);
    };

    const handleGetEpiCompanyAssociation = async (epiId: number) => {
        if (!epiId) {
            return null;
        }

        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const response = await ApiClient.post(
                `/crud/get/epirecords_submaster_companies/${epiId}/epirecord_submaster_id`
            );
            const associations = normalizeEpiCompanyAssociations(response.data);

            return associations.find((association) => association.submaster_id === submasterId) ?? associations[0] ?? null;
        } catch (error) {
            console.error("Erro ao buscar associação do EPI com empresa:", error);
            return null;
        }
    };

    const handleLoadEpiCompanyAssociation = async (epiId: number) => {
        const association = await handleGetEpiCompanyAssociation(epiId);
        setSelectedCompanyId(association?.submaster_company_id ?? 0);
    };

    const handleGetCompanies = async () => {
        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const data = new FormData();

            data.append("submaster_id", String(submasterId));
            data.append("action", "list");

            const response: any = await ApiClient.post(
                `/crud/companyForSubmaster/submaster_company/${submasterId}`,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response?.status >= 200 && response?.status < 300) {
                setCompanies(normalizeCompanies(response.data));
            }
        } catch (error) {
            toast.error("Erro ao buscar empresas.");
        }
    };

    const handleGetDefaultCompanyData = async () => {
        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const response = await ApiClient.post(`/crud/getdata/Submaster/${submasterId}/true`);
            const payload = Array.isArray(response.data)
                ? response.data[0]
                : Array.isArray(response.data?.data)
                    ? response.data.data[0]
                    : response.data;

            setDefaultCompany({
                id: 0,
                name: String(payload?.fantasy_name ?? payload?.name ?? localStorage.getName() ?? "").trim(),
                cnpj: String(payload?.cnpj ?? payload?.CNPJ ?? "").trim(),
                image: String(payload?.submaster_logo_url ?? ""),
            });
        } catch (error) {
            setDefaultCompany((currentCompany) => ({
                ...currentCompany,
                name: currentCompany.name || String(localStorage.getName() ?? ""),
            }));
        }
    };

    const isLowStock = (epi: DataRow) =>
        Number(epi.quantity) <= Number(epi.minimumstock);
   
    const columns: TableColumn<DataRow>[] = [
        {
            name: <span><i className="bi bi-person-fill me-1 text-primary"></i><span className="text-primary fw-bold">Nome</span></span>,
            selector: (row) => row.epiName,
            sortable: true,
            grow: 2,
            minWidth: "220px",
            wrap: true,
            cell: (row) => (
                <div
                    className="w-100 py-2"
                    style={{
                        whiteSpace: "normal",
                        overflowWrap: "anywhere",
                        lineHeight: "1.3",
                    }}
                >
                    {row.epiName}
                </div>
            ),
        },
        {
            name: <span><i className="bi bi-tags-fill me-1 text-warning"></i><span className="text-warning fw-bold">CA</span></span>,
            selector: (row) => row.ca,
            sortable: true,
        },
        {
            name: <span><i className="bi bi-box-seam me-1 text-success"></i><span className="text-success fw-bold">{stockControlEnabled ? "Saldo no estoque" : "Estoque"}</span></span>,
            selector: (row) => row.quantity,
            sortable: true,
        },
        ...(stockControlEnabled ? [
            {
                name: <span><i className="bi bi-speedometer2 me-1 text-secondary"></i><span className="text-secondary fw-bold">Mínimo</span></span>,
                selector: (row: DataRow) => row.minimumstock,
                sortable: true,
            },
            {
                name: <span><i className="bi bi-exclamation-triangle me-1 text-warning"></i><span className="text-warning fw-bold">Situação</span></span>,
                cell: (row: DataRow) => isLowStock(row) ? (
                    <span className="badge bg-warning text-dark">Estoque baixo</span>
                ) : (
                    <span className="badge bg-success">Regular</span>
                ),
                sortable: true,
                sortFunction: (first: DataRow, second: DataRow) =>
                    Number(isLowStock(second)) - Number(isLowStock(first)),
                minWidth: "130px",
            },
        ] : []),
        ...(stockControlEnabled ? [{
            name: <span><i className="bi bi-currency-dollar me-1 text-success"></i><span className="text-success fw-bold">Preço médio</span></span>,
            selector: (row: DataRow) => Number(row.average_price || 0),
            sortable: true,
            minWidth: "130px",
            cell: (row: DataRow) => formatCurrency(row.average_price),
        } as TableColumn<DataRow>] : []),
        {
            name: <span><i className="bi bi-calendar-date-fill me-1 text-danger"></i><span className="text-danger fw-bold">Validade</span></span>,
            selector: (row) => {
            const date = new Date(row.expirationDate);
            const day = date.getUTCDate().toString().padStart(2, "0");
            const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
            const year = date.getUTCFullYear();
            return `${day}/${month}/${year}`;
            },
            sortable: true,
        },
        {
            name: <span><i className="bi bi-check-circle-fill me-1 text-success"></i><span className="text-success fw-bold">Estado</span></span>,
            cell: (row) =>
            row.activeepi ? (
                <span className="badge bg-success">Ativo</span>
            ) : (
                <span className="badge bg-secondary">Inativo</span>
            ),
            sortable: true,
        },
        ...(canEpiEdit ? [{
            name: <span><i className="bi bi-pencil-square me-1 text-primary"></i><span className="text-primary fw-bold">Editar</span></span>,
            cell: (row) => (
            <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => handleButtonUpdate(row.id)}
                title="Editar"
            >
                <i className="bi bi-pencil-fill"></i>
            </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        } as TableColumn<DataRow>] : []),
        {
            name: <span><i className="bi bi-image-fill me-1 text-info"></i><span className="text-info fw-bold">Ver Imagem</span></span>,
            cell: (row) => (
            <button
                className="btn btn-outline-info btn-sm"
                onClick={() => handleViewImg(row.id)}
                title="Ver Imagem"
            >
                <i className="bi bi-eye-fill"></i>
            </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    // Custom styles mantendo hover e cores suaves
    const customStyles = {
    headCells: {
        style: {
        fontWeight: "600",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
        },
    },
    rows: {
        style: {
        minHeight: "50px",
        "&:hover": {
            backgroundColor: "#e3f2fd", // azul suave para hover
        },
        },
    },
    pagination: {
        style: {
        borderTop: "1px solid #dee2e6",
        paddingTop: "10px",
        },
    },
    };

    const handleButtonUpdate =  (id: number) => {

        const selectedItem = getData.find((item) => item.id === id);

        setShowEmployeesFormUpdate(true)

        setidEpi(id)
        setSelectedCompanyId(0)
        handleLoadEpiCompanyAssociation(id)


        console.log("expiration not converte date", selectedItem?.expirationDate)


        const date = new Date(selectedItem?.expirationDate ?? "");
        const formattedDate = date.toISOString().split('T')[0]; // '2025-04-24'

        setFilterText("")
        console.log("expiration date", formattedDate)

        setFormData({
            id: selectedItem?.id ?? 0,
            epiName: selectedItem?.epiName ?? "",
            epitype:selectedItem?.epitype ?? "",
            expirationDate:formattedDate, 
            epiinternalCode:selectedItem?.epiinternalCode ?? "",
            epimanufacturerCode: selectedItem?.epimanufacturerCode ?? "",
            quantity: selectedItem?.quantity ?? 0,
            average_price: selectedItem?.average_price ?? null,
            ca: selectedItem?.ca ?? "",
            minimumstock: selectedItem?.minimumstock ?? 0,
            activeepi: selectedItem?.activeepi ?? false,
            due_day: selectedItem?.due_day ?? 0

        });
    }

    const [showImageModal, setShowImageModal] = useState(false);
    const [modalImages, setModalImages] = useState<ModalImage[]>([]);
    const [deletingModalImageId, setDeletingModalImageId] = useState<number | null>(null);

   const canDeleteImage = (id: number): Promise<boolean> => {
    return new Promise(async (resolve, reject) => {
        try {
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const response = await ApiClient.post("/crud/getdataEpi/EpicontrolEmployeesSubmaster/" + id);

        if (response.data && Object.keys(response.data).length > 0) {
            console.log("Tem dados de imagem:", response.data);
            resolve(true); // Há dados, não pode deletar
        } else {
            console.log("Não tem dados de imagem");
            resolve(false); // Não há dados, pode deletar
        }
        } catch (error) {
        console.error("Erro ao verificar imagem:", error);
        reject(error); // Algum erro na requisição
        }
    });
    };

    const getViewImgEpi = async (id:number) => {
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const response = await ApiClient.post("/crud/getdataEpi/EpirecordsImageSubmaster/" + id);

        const imageList = response.data;

        if (imageList.length === 0) {
            toast.warning("Nenhuma imagem encontrada para este EPI. Mas você pode adicionar mais imagens.");
        }

       

         setModalImages(
            imageList.map((img: any) => ({
                id: img.id,
                url: `https://alexios.com.br:9597/uploads/epiMainimg/${img.mainImageUrl}`,
            }))
        );


        console.log("DADOS EM ITEM ====>>>", imageList)
        setShowImageModal(true);
    }
    
   /* const  handleDeleteImg  = async (idImg: number): Promise<boolean> => {
        return new Promise(async (resolve, reject) => {
            try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const response = await ApiClient.post("/crud/delete/EpirecordsImageSubmaster/" + idImg);

            if (response.data && Object.keys(response.data).length > 0) {
                console.log("Tem dados de imagem:", response.data);
                resolve(true); // Há dados, não pode deletar
            } else {
                console.log("Não tem dados de imagem");
                resolve(false); // Não há dados, pode deletar
            }
            } catch (error) {
            console.error("Erro ao verificar imagem:", error);
            reject(error); // Algum erro na requisição
            }
        });
    };*/

    const  handleDeleteImg  = async (idImg: number): Promise<boolean> => {
        if (deletingModalImageId === idImg) {
            return false;
        }

         return new Promise(async (resolve, reject) => {
            try {
                setDeletingModalImageId(idImg);
                const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
                const response = await ApiClient.post(
                `/crud/delete/EpirecordsImageSubmaster/${idImg}/${localStorage.getId()}`
                );

                if (response?.data?.res) {
                    setModalImages((currentImages) =>
                        currentImages.filter((img) => img.id !== idImg)
                    );
                    toast.success("Imagem removida com sucesso!");
                    setDeletingModalImageId(null);
                    resolve(true);
                } else {
                    toast.warning(
                        response?.data?.message ||
                            "Imagem não foi deletada. Por favor, verifique sua conexão."
                    );
                    setDeletingModalImageId(null);
                    resolve(false);
                }

               
            } catch (error) {
                console.error("Erro ao verificar imagem:", error);
                toast.warning("Imagem não foi deletada. Por favor, verifique sua conexão.")

                reject(error); // Algum erro na requisição
            }
        });

    };
    const handleViewImg = async (id:number) => {
        
        setidEpi(id)

        try {
            canDeleteImage(id).then((res) => {
                if (res) {
                    // Existe imagem vinculada — por exemplo, impedir a exclusão
                    console.log("Não pode deletar. Há dados de imagem.");
                    setcanDeleteImg(true)
                } else {
                    // Não existe imagem vinculada — permitir a exclusão
                    console.log("Pode deletar. Sem dados de imagem.");
                    setcanDeleteImg(false)
                }
                getViewImgEpi(id)
            }).catch((err) => {
                console.error("Erro ao verificar se pode deletar:", err);
            });

        } catch (error) {
            console.error("Erro ao buscar imagens:", error);
            toast.warning("Erro ao buscar imagens do EPI.");
        }
        
    }

    const handleSelectedRowsChange = (selection: { selectedRows: DataRow[] }) => {
        setSelectedEpis(selection.selectedRows);
    };

    const handleBulkDelete = async () => {
        if (selectedEpisForDeletion.length === 0) {
            toast.warning("Selecione ao menos um EPI para excluir.");
            return;
        }

        setBulkDeleteLoading(true);

        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const epiIds = selectedEpisForDeletion.map((item) => item.id);
            const previewResponse = await ApiClient.post("/crud/epi/delete-preview", {
                submasterId,
                epiIds,
            });

            if (!previewResponse?.data?.res) {
                toast.warning(previewResponse?.data?.message || "Não foi possível validar a exclusão dos EPIs.");
                return;
            }

            const previewData = previewResponse.data.data as EpiDeletePreviewPayload;

            if (!previewData.deletable.length) {
                if (previewData.blocked.length > 0) {
                    toast.warning(
                        `EPI já foi retirado não pode ser apagado.\n${buildBlockedDeleteMessage(previewData.blocked)}`
                    );
                    return;
                }

                toast.info("Nenhum EPI elegível para exclusão foi encontrado.");
                return;
            }

            const confirmed = window.confirm(buildDeletePreviewMessage(previewData));

            if (!confirmed) {
                return;
            }

            const deleteResponse = await ApiClient.post("/crud/epi/delete-batch", {
                submasterId,
                epiIds,
            });

            if (!deleteResponse?.data?.res) {
                toast.error(deleteResponse?.data?.message || "Erro ao excluir os EPIs selecionados.");
                return;
            }

            const deletedItems = Array.isArray(deleteResponse.data?.data?.deleted)
                ? deleteResponse.data.data.deleted
                : [];
            const blockedItems = Array.isArray(deleteResponse.data?.data?.blocked)
                ? deleteResponse.data.data.blocked
                : [];
            const deletedCount = deletedItems.length;

            if (deletedCount > 0) {
                toast.success(`${deletedCount} ${pluralizeEpi(deletedCount)} excluíd${deletedCount === 1 ? "o" : "os"} com sucesso.`);
            }

            if (blockedItems.length > 0) {
                toast.warning(
                    `EPI já foi retirado não pode ser apagado.\n${buildBlockedDeleteMessage(blockedItems)}`
                );
            }

            await handlegetDataEpi();
            setSelectedEpis([]);
            setStockSelections({});
            setClearSelectedRows((currentValue) => !currentValue);
        } catch (error) {
            console.error("Erro ao excluir EPIs:", error);
            const message = axios.isAxiosError(error)
                ? error.response?.data?.message
                : null;
            toast.error(message || "Erro ao excluir os EPIs selecionados.");
        } finally {
            setBulkDeleteLoading(false);
        }
    };



    const [previewImages, setPreviewImages] = useState<PreviewImage[]>([]);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const createMinimumStockInputRef = useRef<HTMLInputElement | null>(null);
    const updateMinimumStockInputRef = useRef<HTMLInputElement | null>(null);

    // Função de validação
    const validateFormData = (formData: any, requireImage = false) => {
        // Verificando se algum campo está vazio
        if (!formData.epiName?.trim()) {
          toast.error("O nome do EPI é obrigatório.");
          return false;
        }
        const quantity = Number(formData.quantity);
        if (
          !Number.isInteger(quantity) ||
          quantity < 0 ||
          (!stockControlEnabled && quantity === 0 && formData.activeepi !== false)
        ) {
          toast.error(
            stockControlEnabled
              ? "A quantidade deve ser um número inteiro igual ou maior que zero."
              : "A quantidade do EPI é obrigatória."
          );
          return false;
        }
        const minimumStock = Number(formData.minimumstock);
        const minimumStockIsEmpty =
          formData.minimumstock === "" ||
          formData.minimumstock === null ||
          formData.minimumstock === undefined;
        if (
          minimumStockIsEmpty ||
          !Number.isInteger(minimumStock) ||
          minimumStock < 0 ||
          (minimumStock === 0 && formData.activeepi !== false)
        ) {
          toast.error("A quantidade mínima de estoque é obrigatória.");
          return false;
        }
        if (!formData.epitype?.trim()) {
          toast.error("O tipo de EPI é obrigatório.");
          return false;
        }
        if (!formData.epiinternalCode?.trim()) {
          toast.error("O código interno do EPI é obrigatório.");
          return false;
        }
        if (!formData.epimanufacturerCode?.trim()) {
          toast.error("O código de fabricante é obrigatório.");
          return false;
        }
        if (!formData.ca?.trim()) {
          toast.error("O C.A é obrigatório.");
          return false;
        }
        if (!formData.expirationDate) {
            toast.error("A data de validade é obrigatória.");
            return false;
        }
        const dueDay = Number(formData.due_day);
        if (!Number.isInteger(dueDay) || dueDay < 0 || dueDay > MAX_EPI_DUE_DAYS) {
            toast.error(`O prazo de validade deve ser um número inteiro entre 0 e ${MAX_EPI_DUE_DAYS} dias.`);
            return false;
        }
        if (requireImage && selectedFiles.length === 0) {
            toast.error("A imagem do EPI é obrigatória.");
            return false;
        }
        return true;
    };

    const minimumStockIsAboveCurrentQuantity = () =>
        formData.activeepi !== false &&
        Number(formData.minimumstock) > Number(formData.quantity);

    const requestMinimumStockConfirmation = (
        action: MinimumStockConfirmationAction
    ) => {
        if (!minimumStockIsAboveCurrentQuantity()) {
            return false;
        }

        setMinimumStockConfirmationAction(action);
        return true;
    };

    const getCreatedEpiId = (payload: any) => {
        const data = Array.isArray(payload)
            ? payload[0]
            : Array.isArray(payload?.data)
                ? payload.data[0]
                : payload?.data ?? payload;

        return Number(
            data?.id ??
            data?.insertId ??
            data?.epirecordId ??
            data?.epirecord_submaster_id ??
            data?.epirecordSubmasterId ??
            0
        );
    };

    const handleCreateEpiCompanyAssociation = async (epiId: number) => {
        if (!epiId) {
            toast.warning("EPI cadastrado, mas não foi possível identificar o ID para associar à empresa.");
            return;
        }

        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const selectedCompany = getSelectedCompanyPayload();
            if (!selectedCompany) {
                toast.warning("EPI cadastrado, mas nenhuma empresa válida foi encontrada para associação.");
                return;
            }

            const response = await ApiClient.post("/crud/create/epirecords_submaster_companies", {
                epirecord_submaster_id: epiId,
                submaster_company_id: selectedCompany.submaster_company_id,
                submaster_id: submasterId,
                company_name: selectedCompany.company_name,
                company_cnpj: selectedCompany.company_cnpj,
            });

            if (!(response.status >= 200 && response.status < 300)) {
               toast.warning("EPI cadastrado, mas a associação com a empresa não foi criada.");
            }
        } catch (error) {
            console.error("Erro ao associar EPI à empresa:", error);
            toast.warning("EPI cadastrado, mas a associação com a empresa não foi criada.");
        }
    };

    const handleUpdateEpiCompanyAssociation = async (epiId: number) => {
        if (!epiId) {
            toast.warning("EPI atualizado, mas não foi possível identificar o ID para atualizar a empresa.");
            return;
        }

        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const selectedCompany = getSelectedCompanyPayload();
            if (!selectedCompany) {
                //toast.warning("EPI atualizado, mas nenhuma empresa válida foi encontrada para associação.");
                return;
            }

            const associationPayload = {
                epirecord_submaster_id: epiId,
                submaster_company_id: selectedCompany.submaster_company_id,
                submaster_id: submasterId,
                company_name: selectedCompany.company_name,
                company_cnpj: selectedCompany.company_cnpj,
                updated_at: new Date(),
            };
            const currentAssociation = await handleGetEpiCompanyAssociation(epiId);

            if (currentAssociation?.id) {
                const response = await ApiClient.post(
                    `/crud/updatedata/epirecords_submaster_companies/${currentAssociation.id}`,
                    associationPayload
                );

                if (!(response.status >= 200 && response.status < 300)) {
                    toast.warning("EPI atualizado, mas a associação com a empresa não foi atualizada.");
                }

                return;
            }

            const response = await ApiClient.post(
                "/crud/create/epirecords_submaster_companies",
                associationPayload
            );

            if (!(response.status >= 200 && response.status < 300)) {
                toast.warning("EPI atualizado, mas a associação com a empresa não foi criada.");
            }
        } catch (error) {
            console.error("Erro ao atualizar associação do EPI com empresa:", error);
            toast.warning("EPI atualizado, mas a associação com a empresa não foi atualizada.");
        }
    };

    const submitCreateEpi = async (): Promise<boolean> => {
        try {
            const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
            const timestamp = new Date(formData.expirationDate);
            const response = await ApiClient.post("/crud/create/EpirecordsSubmaster", {
                epiName: formData.epiName,
                epitype: formData.epitype,
                expirationDate: timestamp, 
                epiinternalCode: formData.epiinternalCode,
                epimanufacturerCode: formData.epimanufacturerCode,
                quantity: Number(formData.quantity),
                minimumstock:Number(formData.minimumstock),
                ca: formData.ca,
                submasterId: submasterId,
                activeepi: formData.activeepi,
                due_day: Number(formData.due_day)
            });
            // Verifica se a requisição foi bem-sucedida (código HTTP 200-299)
            if (response.status >= 200 && response.status < 300) {
            //resetForm();               
              const createdEpiId = Number(response.data?.id ?? getCreatedEpiId(response.data));
             // await handleCreateEpiCompanyAssociation(createdEpiId);
              void handleSubmitImage(String(createdEpiId));
              return true;
            }else{
                toast.warning("Erro ao registrar, por favor tente novamente.");
                return false;
            }
        } catch (e) {
            const message = axios.isAxiosError(e)
                ? e.response?.data?.message || e.response?.data?.error
                : null;
            toast.warning(message || "Erro ao registrar, por favor tente novamente.");
            return false;
        }
    };

    const handleSubmit = async () => {
        if (!validateFormData(formData, true)) {
            return;
        }
        if (requestMinimumStockConfirmation("create")) {
            return;
        }

        if (await submitCreateEpi()) {
            setShowFormCreateEmployess(false);
        }
    };
    const handleSubmitImage = async (id: string) => {
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const data = new FormData();
        data.append('epirecordId', id);
        selectedFiles.forEach((file, index) => {
         data.append(`mainImageUrl`, file); 
        });
        try {
            await ApiClient.post(
                `/crud/createImgEpi/EpirecordsImageSubmaster/`+ Number(localStorage.getId()),
                data,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                }
            );
            setTimeout(() => {
                window.location.reload();
            }, 1500);
            toast.success("Cadastrado com sucesso! 🎉");
        } catch (error) {
            setTimeout(() => {
                window.location.reload();
            }, 1500);
            toast.warning("As imagens não foram inseridas, por favor tente incluir novamente.");
        }
    }
    const [formDataimg, setformDataimg] = useState<{
        ca: File[]; // ou FileList se preferir
        // ... outros campos
    }>();
    const handleChangeImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files ?? []);
        const previews = files.map(file => ({
            file,
            url: URL.createObjectURL(file)
        }));
        setSelectedFiles(files);
        setPreviewImages(previews);
       //  console.log("imagem ... ", files)
    };
    const handleRemoveImage = (index: number) => {
        const updatedPreviews = [...previewImages];
        const updatedFiles = [...selectedFiles];

        URL.revokeObjectURL(updatedPreviews[index].url);

        updatedPreviews.splice(index, 1);
        updatedFiles.splice(index, 1);

        setPreviewImages(updatedPreviews);
        setSelectedFiles(updatedFiles);

        if (updatedFiles.length === 0 && fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };
    const matchesEpiFilter = (item: DataRow) => {
        const normalizedFilter = filterText.toLocaleLowerCase("pt-BR");

        return (
            item.epiName?.toLocaleLowerCase("pt-BR").includes(normalizedFilter) ||
            item.epitype?.toLocaleLowerCase("pt-BR").includes(normalizedFilter) ||
            item.ca?.toLocaleLowerCase("pt-BR").includes(normalizedFilter) ||
            item.expirationDate?.toLocaleLowerCase("pt-BR").includes(normalizedFilter)
        );
    };

    const filteredData = getData.filter(matchesEpiFilter);
    const epiById = new Map(getData.map((epi) => [epi.id, epi]));
    const filteredStockGroups = stockGroups.map((group) => {
        const stockEpis = group.items
            .map((stockItem) => {
                const epi = epiById.get(stockItem.id);
                return epi
                    ? { ...epi, quantity: Number(stockItem.stock_quantity || 0) }
                    : null;
            })
            .filter((epi): epi is DataRow => epi !== null);

        return {
            ...group,
            epis: stockEpis.filter(matchesEpiFilter),
            lowStockCount: stockEpis.filter(isLowStock).length,
        };
    });
    const totalEpis = getData.length;
    const activeEpis = getData.filter((item) => item.activeepi).length;
    const lowStockEpis = getData.filter(isLowStock).length;
    const filteredCount = stockControlEnabled
        ? filteredStockGroups.reduce((total, group) => total + group.epis.length, 0)
        : filteredData.length;

    const selectedEpisForDeletion = stockControlEnabled
        ? Array.from(
            new Map(
                Object.values(stockSelections)
                    .flat()
                    .map((epi) => [epi.id, epi])
            ).values()
        )
        : selectedEpis;

    const handleStockSelectedRowsChange = (
        stockId: number,
        selection: { selectedRows: DataRow[] }
    ) => {
        setStockSelections((currentSelections) => ({
            ...currentSelections,
            [stockId]: selection.selectedRows,
        }));
    };

    const handleGetStockGroups = async () => {
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));

        try {
            setStockGroupsLoading(true);
            const stocksResponse = await ApiClient.post("/stocks/list", {});
            const stocks: StockSummary[] = Array.isArray(stocksResponse?.data?.data)
                ? stocksResponse.data.data
                : [];
            const itemResponses = await Promise.all(
                stocks.map((stock) => ApiClient.post("/stocks/items", { stockId: stock.id }))
            );

            setStockGroups(
                stocks.map((stock, index) => ({
                    stock,
                    items: Array.isArray(itemResponses[index]?.data?.data)
                        ? itemResponses[index].data.data.map((item: any) => ({
                            id: Number(item.id),
                            stock_quantity: Number(item.stock_quantity || 0),
                        }))
                        : [],
                }))
            );
        } catch (error) {
            console.error("Erro ao carregar os EPIs separados por estoque:", error);
            setStockGroups([]);
            toast.error("Não foi possível carregar os EPIs separados por estoque.");
        } finally {
            setStockGroupsLoading(false);
        }
    };

    const handlegetDataEpi = async () => {
        
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const response = await ApiClient.post("/crud/getdata/EpirecordsSubmaster/" + String(submasterId)  + "/false" );
    
        // console.log("dados submaster",response.data)
        const formatdata = response.data.map((item: any) => ({
            id:item.id,
            name: item.name,
            epiName: item.epiName,
            epitype: item.epitype,
            expirationDate: item.expirationDate, 
            epiinternalCode: item.epiinternalCode,
            epimanufacturerCode: item.epimanufacturerCode,
            quantity: Number(item.quantity),
            average_price: item.average_price,
            minimumstock:Number(item.minimumstock),
            ca: item.ca,
            activeepi: item.activeepi,
            due_day:item.due_day

        }));

        const sortedEpis = sortEpisAlphabetically(formatdata);

        setFormData(formatdata)
        setgetData(sortedEpis)
    }



    const submitUpdateEpi = async (): Promise<boolean> => {
         try {
             const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
             const timestamp = new Date(formData.expirationDate);
             const response = await ApiClient.post("/crud/updatedata/EpirecordsSubmaster/" + idEpi, {
                 epiName: formData.epiName,
                 epitype: formData.epitype,
                 expirationDate: timestamp, 
                 epiinternalCode: formData.epiinternalCode,
                 epimanufacturerCode: formData.epimanufacturerCode,
                 quantity: Number(formData.quantity),
                 minimumstock:Number(formData.minimumstock),
                 ca: formData.ca,
                 submasterId: submasterId,
                 activeepi:formData.activeepi,
                 due_day:Number(formData.due_day)
             });
             // Verifica se a requisição foi bem-sucedida (código HTTP 200-299)
             if (response.status >= 200 && response.status < 300) {
             //resetForm();               
                 const updatedEpiId = Number(response.data?.id ?? idEpi);
                 //await handleUpdateEpiCompanyAssociation(updatedEpiId);
                 void handleSubmitImage(String(updatedEpiId));
                 return true;
              }else{
                  toast.warning("Erro ao registrar, por favor tente novamente.");
                  return false;
              }
          } catch (e) {
              const message = axios.isAxiosError(e)
                  ? e.response?.data?.message || e.response?.data?.error
                  : null;
              toast.warning(message || "Erro ao registrar, por favor tente novamente.");
              return false;
          }
     };

    const handleSubmitUpdate = async () => {
        if (!validateFormData(formData)) {
            return;
        }
        if (requestMinimumStockConfirmation("update")) {
            return;
        }

        if (await submitUpdateEpi()) {
            setShowEmployeesFormUpdate(false);
        }
    };

    const handleCancelMinimumStockConfirmation = () => {
        if (minimumStockConfirmationLoading) {
            return;
        }

        const action = minimumStockConfirmationAction;
        setMinimumStockConfirmationAction(null);

        window.setTimeout(() => {
            const input = action === "update"
                ? updateMinimumStockInputRef.current
                : createMinimumStockInputRef.current;
            input?.focus();
            input?.select();
        }, 0);
    };

    const handleConfirmMinimumStock = async () => {
        if (!minimumStockConfirmationAction || minimumStockConfirmationLoading) {
            return;
        }

        const action = minimumStockConfirmationAction;
        setMinimumStockConfirmationLoading(true);

        try {
            const saved = action === "update"
                ? await submitUpdateEpi()
                : await submitCreateEpi();

            if (saved) {
                setMinimumStockConfirmationAction(null);
                if (action === "update") {
                    setShowEmployeesFormUpdate(false);
                } else {
                    setShowFormCreateEmployess(false);
                }
            }
        } finally {
            setMinimumStockConfirmationLoading(false);
        }
    };


    useEffect(() => {
        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        ApiClient.post("/reportPermissions", {})
            .then((response) => {
                const enabled = response?.data?.stock_control_permission_enabled === true;
                setStockControlEnabled(enabled);
                setMasterDataDeleteEnabled(
                    response?.data?.master_data_delete_permission_enabled === true
                );

                if (enabled) {
                    void handleGetStockGroups();
                } else {
                    setStockGroups([]);
                    setStockSelections({});
                }
            })
            .catch(() => {
                setStockControlEnabled(false);
                setMasterDataDeleteEnabled(false);
                setStockGroups([]);
                setStockSelections({});
            });
        handlegetDataEpi()
        handleGetCompanies()
        handleGetDefaultCompanyData()
    }, []);

    return (
    <LayoutSubmaster>
       <div className="report-config-page epi-config-page">
            {!showEmployeesFormUpdate ? (
                <div>
                    <section className="dashboard-hero report-hero mb-4">
                        <div className="report-hero__content">
                            <span className="pill-badge">EPIs</span>
                            <h1 className="dashboard-title">Cadastro de EPI</h1>
                            <p className="dashboard-subtitle">
                                Gerencie os equipamentos cadastrados, acompanhe o estoque e mantenha os dados do EPI organizados.
                            </p>
                        </div>
                        <div className="d-flex flex-wrap gap-2 epi-hero-actions">
                            <div className="report-hero__badge">
                                <i className="bi bi-shield-check" />
                                <div>
                                    <span>Controle de estoque</span>
                                    <strong>{filteredCount} registros visíveis</strong>
                                </div>
                            </div>
                            {canEpiCreate && <button
                                className="btn btn-primary epi-primary-action"
                                onClick={() => {
                                resetData();
                                previewImages.forEach((image) => URL.revokeObjectURL(image.url));
                                setPreviewImages([]);
                                setSelectedFiles([]);
                                if (fileInputRef.current) {
                                    fileInputRef.current.value = "";
                                }
                                setSelectedCompanyId(0);
                                setShowFormCreateEmployess(true);
                                }}
                            >
                                <i className="bi bi-plus-circle me-2"></i> Cadastrar EPI
                            </button>}
                        </div>
                    </section>

                    <div className="row g-3 mb-4">
                        <div className="col-md-4">
                            <article className="dashboard-card metric-card soft report-metric-card">
                                <div className="metric-card__icon">
                                    <i className="bi bi-box-seam fs-4 text-primary" />
                                </div>
                                <div>
                                    <p className="metric-card__eyebrow">Total de EPIs</p>
                                    <h2 className="metric-card__value">{totalEpis}</h2>
                                    <p className="metric-card__caption">Itens cadastrados no painel</p>
                                </div>
                            </article>
                        </div>
                        <div className="col-md-4">
                            <article className="dashboard-card metric-card soft report-metric-card">
                                <div className="metric-card__icon">
                                    <i className="bi bi-check2-circle fs-4 text-primary" />
                                </div>
                                <div>
                                    <p className="metric-card__eyebrow">Ativos</p>
                                    <h2 className="metric-card__value">{activeEpis}</h2>
                                    <p className="metric-card__caption">EPIs liberados para operação</p>
                                </div>
                            </article>
                        </div>
                        <div className="col-md-4">
                            <article className="dashboard-card metric-card soft report-metric-card">
                                <div className="metric-card__icon">
                                    <i className="bi bi-exclamation-triangle fs-4 text-primary" />
                                </div>
                                <div>
                                    <p className="metric-card__eyebrow">Estoque baixo</p>
                                    <h2 className="metric-card__value">{lowStockEpis}</h2>
                                    <p className="metric-card__caption">Itens no limite do estoque mínimo</p>
                                </div>
                            </article>
                        </div>
                    </div>

                    <section className="section-panel report-filter-panel mb-4">
                        <div className="section-heading">
                            <div>
                                <h3>Consulta de EPI</h3>
                                <p>Busque por nome, tipo ou validade para localizar um equipamento.</p>
                            </div>
                            <span className="pill-badge">{filteredCount} resultado(s)</span>
                        </div>

                        <div className="row g-3 align-items-end">
                            <div className="col-lg-5 col-md-8">
                                <label className="form-label">Pesquisar EPI</label>
                                <div className="input-group report-input">
                                    <span className="input-group-text bg-white">
                                        <i className="bi bi-search text-primary"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Filtrar por nome, tipo ou validade"
                                        value={filterText}
                                        onChange={(e) => setFilterText(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-4">
                                <button className="btn btn-outline-secondary w-100 report-clear-btn" onClick={() => setFilterText("")}>
                                    <i className="bi bi-arrow-counterclockwise me-1"></i>
                                    Limpar
                                </button>
                            </div>
                        </div>
                    </section>

                    <section className="section-panel report-table-panel">
                            <div className="section-heading">
                                <div>
                                    <h3>{stockControlEnabled ? "EPIs por estoque" : "Tabela de EPI"}</h3>
                                    <p>
                                        {stockControlEnabled
                                            ? "Consulte o saldo de cada equipamento separado por estoque."
                                            : "Visualize os dados principais do equipamento e acesse rapidamente a edição e as imagens."}
                                    </p>
                                </div>
                                <div className="d-flex flex-wrap gap-2 align-items-center justify-content-end">
                                    {stockControlEnabled && (
                                        <span className="pill-badge">{stockGroups.length} estoque(s)</span>
                                    )}
                                    <span className="pill-badge report-pill-success">{activeEpis} ativos</span>
                                    <span className="pill-badge report-pill-warning">{lowStockEpis} com estoque baixo</span>
                                    {masterDataDeleteEnabled && canEpiDelete && <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => void handleBulkDelete()}
                                        disabled={bulkDeleteLoading || selectedEpisForDeletion.length === 0}
                                    >
                                        <i className={`bi ${bulkDeleteLoading ? "bi-hourglass-split" : "bi-trash3"} me-1`}></i>
                                        Excluir selecionados
                                    </button>}
                                </div>
                            </div>

                            {stockControlEnabled ? (
                                stockGroupsLoading ? (
                                    <div className="py-5 text-center text-muted">
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Carregando EPIs por estoque...
                                    </div>
                                ) : filteredStockGroups.length === 0 ? (
                                    <div className="alert alert-light border mb-0">
                                        Nenhum estoque cadastrado para esta empresa.
                                    </div>
                                ) : (
                                    <div className="d-flex flex-column gap-4">
                                        {filteredStockGroups.map(({ stock, epis, lowStockCount }) => (
                                            <article
                                                key={stock.id}
                                                className={`border rounded-3 overflow-hidden bg-white ${lowStockCount > 0 ? "border-warning" : ""}`}
                                            >
                                                <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 px-3 py-3 bg-light border-bottom">
                                                    <div>
                                                        <h4 className="h6 mb-1">
                                                            <i className="bi bi-box-seam me-2 text-primary"></i>
                                                            {stock.description}
                                                            {stock.is_default && (
                                                                <span className="badge bg-primary ms-2">Padrão</span>
                                                            )}
                                                        </h4>
                                                        <div className="small text-muted">
                                                            <i className="bi bi-building me-1"></i>
                                                            {stock.company_name}
                                                        </div>
                                                        {stock.observation && (
                                                            <div className="small text-muted mt-1">{stock.observation}</div>
                                                        )}
                                                    </div>
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {lowStockCount > 0 ? (
                                                            <span className="pill-badge report-pill-warning">
                                                                <i className="bi bi-exclamation-triangle me-1"></i>
                                                                {lowStockCount} EPI(s) com estoque baixo
                                                            </span>
                                                        ) : (
                                                            <span className="pill-badge report-pill-success">
                                                                <i className="bi bi-check-circle me-1"></i>
                                                                Estoque regular
                                                            </span>
                                                        )}
                                                        <span className="pill-badge">{epis.length} EPI(s)</span>
                                                        <span className="pill-badge report-pill-success">
                                                            {Number(stock.total_quantity || 0)} unidade(s)
                                                        </span>
                                                    </div>
                                                </div>
                                                <DataTable
                                                    columns={columns}
                                                    data={epis}
                                                    pagination
                                                    highlightOnHover
                                                    pointerOnHover
                                                    selectableRows={masterDataDeleteEnabled && canEpiDelete}
                                                    clearSelectedRows={clearSelectedRows}
                                                    onSelectedRowsChange={(selection) =>
                                                        handleStockSelectedRowsChange(stock.id, selection)
                                                    }
                                                    customStyles={customStyles}
                                                    noDataComponent="Nenhum EPI encontrado neste estoque."
                                                    paginationComponentOptions={{
                                                        rowsPerPageText: "Linhas por página",
                                                        rangeSeparatorText: "de",
                                                        selectAllRowsItem: true,
                                                        selectAllRowsItemText: "Selecionar todos",
                                                    }}
                                                />
                                            </article>
                                        ))}
                                    </div>
                                )
                            ) : (
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    highlightOnHover
                                    pointerOnHover
                                    selectableRows={masterDataDeleteEnabled && canEpiDelete}
                                    clearSelectedRows={clearSelectedRows}
                                    onSelectedRowsChange={handleSelectedRowsChange}
                                    customStyles={customStyles}
                                    paginationComponentOptions={{
                                    rowsPerPageText: "Linhas por página",
                                    rangeSeparatorText: "de",
                                    selectAllRowsItem: true,
                                    selectAllRowsItemText: "Selecionar todos",
                                    }}
                                />
                            )}
                            <style>{`
                                .btn-outline-primary:hover {
                                transform: scale(1.1);
                                transition: 0.2s;
                                }
                                .btn-outline-info:hover {
                                transform: scale(1.1);
                                transition: 0.2s;
                                }
                                .badge {
                                font-size: 0.9rem;
                                }
                            `}</style>
                    </section>
                </div>
                ) :
                 <div className="modal fade show d-block">
    <div className="modal-dialog modal-xl">
      <div className="modal-content shadow-lg rounded-3 epi-modal">

        {/* Cabeçalho */}
        <div
          className="modal-header"
          style={{ background: "linear-gradient(90deg, #0d6efd, #5dade2)", color: "#fff" }}
        >
          <h5 className="modal-title" style={{color:"white"}}>
            <i className="bi bi-pencil-square me-2"></i> Editar EPI
          </h5>
          <button
            type="button"
            className="mr-4 mt-4 btn-close btn-close-white"
            onClick={() => setShowEmployeesFormUpdate(false)}
          ></button>
        </div>

        {/* Corpo do Modal */}
        <div className="modal-body epi-modal__body">
          <form>
            <div className="container">

              {/* Linha 1: Nome e Tipo de EPI */}
              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Nome do EPI</label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-person-fill text-primary"></i>
                    </span>
                    <input
                      type="text"
                      id="epiName"
                      name="epiName"
                      className="form-control"
                      placeholder="Nome do equipamento"
                      value={formData.epiName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Tipo de EPI</label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-tags-fill text-warning"></i>
                    </span>
                    <input
                      type="text"
                      id="epitype"
                      name="epitype"
                      className="form-control"
                      placeholder="Tipo de EPI"
                      value={formData.epitype}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Linha 2: Códigos */}
              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Código Interno</label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-hash text-secondary"></i>
                    </span>
                    <input
                      type="text"
                      id="epiinternalCode"
                      name="epiinternalCode"
                      className="form-control"
                      placeholder="Código interno EPI"
                      value={formData.epiinternalCode}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Código do Fabricante</label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-gear-fill text-secondary"></i>
                    </span>
                    <input
                      type="text"
                      id="epimanufacturerCode"
                      name="epimanufacturerCode"
                      className="form-control"
                      placeholder="Código do fabricante EPI"
                      value={formData.epimanufacturerCode}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Linha 3: C.A e Imagem */}
              <div className="row mb-4 align-items-center">
                <div className="col-md-6 mb-3">
                  <label className="form-label">C.A (Certificado de Aprovação)</label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-file-earmark-text-fill text-info"></i>
                    </span>
                    <input
                      type="text"
                      id="ca"
                      name="ca"
                      className="form-control"
                      placeholder="C.A"
                      value={formData.ca}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-3 mt-3">
                  <label className="form-label">Imagem do EPI</label>
                  <input
                    type="file"
                    id="imagemEpi"
                    name="imagemEpi"
                    className="form-control mb-3"
                    onChange={handleChangeImage}
                    multiple
                    accept="image/*"
                    required
                    ref={fileInputRef}
                  />

                  <div className="d-flex flex-wrap gap-3">
                    {previewImages.map((image, index) => (
                      <div
                        key={index}
                        className="position-relative shadow-sm rounded"
                        style={{ width: 120 }}
                      >
                        <img
                          src={image.url}
                          alt={`preview-${index}`}
                          className="img-thumbnail rounded"
                          style={{ width: "100%", height: "auto", objectFit: "cover" }}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                          onClick={() => handleRemoveImage(index)}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Linha 4: Validade, Quantidade e Estado */}
              <div className="row mb-4 align-items-center">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Data de Validade do Fabricante (EPI)</label>
                  <input
                    type="date"
                    id="expirationDate"
                    name="expirationDate"
                    className="form-control"
                    value={formData.expirationDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Prazo de Validade do EPI (dias, máximo 1825)</label>
                  <input
                    type="number"
                    id="due_day"
                    name="due_day"
                    className="form-control"
                    min={0}
                    max={MAX_EPI_DUE_DAYS}
                    step={1}
                    value={formData.due_day}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-2 mb-3">
                  <label className="form-label">
                    {stockControlEnabled ? "Saldo total nos estoques" : "Quantidade atual em estoque"}
                  </label>
                  <input
                    type="number"
                    id="quantity"
                    name="quantity"
                    className="form-control"
                    placeholder="Qtd"
                    value={formData.quantity}
                    onChange={handleChange}
                    readOnly={stockControlEnabled}
                    title={stockControlEnabled ? "Altere o saldo pelo menu Estoque" : undefined}
                    required
                  />
                  {stockControlEnabled && (
                    <small className="text-muted">Altere separadamente pelo menu Estoque.</small>
                  )}
                </div>

                <div className="col-md-2 mb-3">
                  <label className="form-label">Quantidade mínima em estoque</label>
                  <input
                    type="number"
                    id="minimumstock"
                    name="minimumstock"
                    ref={updateMinimumStockInputRef}
                    className="form-control"
                    placeholder="Qtd mínima"
                    value={formData.minimumstock}
                    onChange={handleChange}
                    required
                  />
                </div>

                {stockControlEnabled && (<div className="col-md-3 mb-3">
                  <label className="form-label">Preço médio do EPI</label>
                  <div className="input-group">
                    <span className="input-group-text">R$</span>
                    <input
                      type="text"
                      className="form-control"
                      value={Number(formData.average_price || 0).toFixed(2).replace(".", ",")}
                      readOnly
                      title="Calculado automaticamente pelas entradas de estoque"
                    />
                  </div>
                  <small className="text-muted">Calculado pelas entradas de estoque.</small>
                </div>)}

                <div className="col-md-4">
                  <label className="form-label">Estado do EPI</label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={formData.activeepi}
                      onChange={(e) =>
                        setFormData({ ...formData, activeepi: e.target.checked })
                      }
                    />
                    <span className={`badge ${formData.activeepi ? "bg-success" : "bg-warning"}`}>
                      {formData.activeepi ? "Ativo" : "Inativo"}
                    </span>
                  </div>
                </div>
              </div>

              {/* Linha 5: Empresa vinculada: 
              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <label htmlFor="submasterCompanyIdUpdate" className="form-label">Empresa</label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-building-fill text-primary"></i>
                    </span>
                    <select
                      id="submasterCompanyIdUpdate"
                      name="submasterCompanyId"
                      className="form-select"
                      value={selectedCompanyId || ""}
                      onChange={handleCompanyChange}
                    >
                      <option value="">Empresa padrão - {getDefaultCompanyName()}</option>
                      {companies.map((company) => (
                        <option key={company.id} value={company.id}>
                          {company.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div> */}

            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="modal-footer epi-modal__footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowEmployeesFormUpdate(false)}
          >
            Fechar
          </button>
          <button
            className="btn btn-outline-primary"
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            onClick={handleSubmitUpdate}
          >
            <i className="bi bi-check-circle me-2"></i> Salvar Alterações
          </button>
        </div>

      </div>
    </div>
  </div>
            }
       </div>

        {showFormCreateEmployess && (
            <div className="modal fade show d-block">
                <div className="modal-dialog modal-xl">
                <div className="modal-content shadow-lg rounded-3 epi-modal">
                    {/* Cabeçalho */}
                    <div
                    className="modal-header"
                    style={{ background: "linear-gradient(90deg, #0d6efd, #5dade2)", color: "#fff" }}
                    >
                    <h5 className="modal-title" style={{color:"white"}}>
                        <i className="bi bi-box-seam me-2"></i> Cadastro de EPI
                    </h5>
                    <button
                        type="button"
                        className="mr-4 mt-4 btn-close btn-close-white"
                        onClick={() => setShowFormCreateEmployess(false)}
                    ></button>
                    </div>

                    {/* Corpo do Modal */}
                    <div className="modal-body epi-modal__body">
                    <form>
                        <div className="container">

                        {/* Linha 1: Nome e Tipo de EPI */}
                        <div className="row mb-4">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="epiName" className="form-label">
                                Nome do EPI
                            </label>
                            <div className="input-group">
                                <span className="input-group-text bg-white"><i className="bi bi-person-fill text-primary"></i></span>
                                <input
                                type="text"
                                id="epiName"
                                name="epiName"
                                className="form-control"
                                placeholder="Nome do equipamento"
                                value={formData.epiName}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            </div>

                            <div className="col-md-6 mb-3">
                            <label htmlFor="epitype" className="form-label">Tipo de EPI</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white"><i className="bi bi-tags-fill text-warning"></i></span>
                                <input
                                type="text"
                                id="epitype"
                                name="epitype"
                                className="form-control"
                                placeholder="Tipo de EPI"
                                value={formData.epitype}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            </div>
                        </div>

                        {/* Linha 2: Códigos */}
                        <div className="row mb-4">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="epiinternalCode" className="form-label">Código Interno</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white"><i className="bi bi-hash text-secondary"></i></span>
                                <input
                                type="text"
                                id="epiinternalCode"
                                name="epiinternalCode"
                                className="form-control"
                                placeholder="Código interno EPI"
                                value={formData.epiinternalCode}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            </div>

                            <div className="col-md-6 mb-3">
                            <label htmlFor="epimanufacturerCode" className="form-label">Código do Fabricante</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white"><i className="bi bi-gear-fill text-secondary"></i></span>
                                <input
                                type="text"
                                id="epimanufacturerCode"
                                name="epimanufacturerCode"
                                className="form-control"
                                placeholder="Código do fabricante EPI"
                                value={formData.epimanufacturerCode}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            </div>
                        </div>

                        {/* Linha 3: C.A e Imagem */}
                        <div className="row mb-4 align-items-center">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="ca" className="form-label">C.A (Certificado de Aprovação)</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white"><i className="bi bi-file-earmark-text-fill text-info"></i></span>
                                <input
                                type="text"
                                id="ca"
                                name="ca"
                                className="form-control"
                                placeholder="C.A"
                                value={formData.ca}
                                onChange={handleChange}
                                required
                                />
                            </div>
                            </div>

                            <div className="col-md-6 mb-3 mt-4">
                            <label htmlFor="imagemEpi" className="form-label">Imagem do EPI</label>
                            <input
                                type="file"
                                id="imagemEpi"
                                name="imagemEpi"
                                className="form-control mb-3"
                                onChange={handleChangeImage}
                                multiple
                                accept="image/*"
                                required
                                ref={fileInputRef}
                            />

                            <div className="d-flex flex-wrap gap-3">
                                {previewImages.map((image, index) => (
                                <div
                                    key={index}
                                    className="position-relative shadow-sm rounded"
                                    style={{ width: 120 }}
                                >
                                    <img
                                    src={image.url}
                                    alt={`preview-${index}`}
                                    className="img-thumbnail rounded"
                                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                                    />
                                    <button
                                    type="button"
                                    className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                    onClick={() => handleRemoveImage(index)}
                                    >
                                    &times;
                                    </button>
                                </div>
                                ))}
                            </div>
                            </div>
                        </div>

                        {/* Linha 4: Validade, Quantidade e Estado */}
                        <div className="row mb-4 align-items-center">
                           <div className="col-md-4 mb-3">
                            <label className="form-label">Data de Validade do Fabricante (EPI)</label>
                            <input
                              type="date"
                              id="expirationDate"
                              name="expirationDate"
                              className="form-control"
                              value={formData.expirationDate}
                              onChange={handleChange}
                            />
                          </div>
                            <div className="col-md-4 mb-3">
                            <label htmlFor="due_day" className="form-label">Prazo de Validade do EPI (dias, máximo 1825)</label>
                            <input
                                type="number"
                                id="due_day"
                                name="due_day"
                                className="form-control"
                                min={0}
                                max={MAX_EPI_DUE_DAYS}
                                step={1}
                                value={formData.due_day}
                                onChange={handleChange}
                            />
                            </div>

                            <div className="col-md-2 mb-3">
                            <label htmlFor="quantity" className="form-label">
                                {stockControlEnabled ? "Quantidade inicial no estoque principal" : "Quantidade atual em estoque"}
                            </label>
                            <input
                                type="number"
                                id="quantity"
                                name="quantity"
                                className="form-control"
                                placeholder="Qtd"
                                value={formData.quantity}
                                onChange={handleChange}
                                required
                            />
                            </div>

                            <div className="col-md-2 mb-3">
                            <label htmlFor="minimumstock" className="form-label">Quantidade mínima em estoque</label>
                            <input
                                type="number"
                                id="minimumstock"
                                name="minimumstock"
                                ref={createMinimumStockInputRef}
                                className="form-control"
                                placeholder="Qtd mínima"
                                value={formData.minimumstock}
                                onChange={handleChange}
                                required
                            />
                            </div>

                            {stockControlEnabled && (<div className="col-md-3 mb-3">
                            <label className="form-label">Preço médio do EPI</label>
                            <div className="input-group">
                                <span className="input-group-text">R$</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={Number(formData.average_price || 0).toFixed(2).replace(".", ",")}
                                    readOnly
                                    title="Calculado automaticamente pelas entradas de estoque"
                                />
                            </div>
                            <small className="text-muted">Calculado pelas entradas de estoque.</small>
                            </div>)}

                            <div className="col-md-4">
                            <label className="form-label">Estado do EPI</label>
                            <div className="d-flex align-items-center gap-2">
                                <input
                                type="checkbox"
                                className="form-check-input"
                                checked={formData.activeepi}
                                onChange={(e) =>
                                    setFormData({ ...formData, activeepi: e.target.checked })
                                }
                                />
                                <span className={`badge ${formData.activeepi ? "bg-success" : "bg-warning"}`}>
                                {formData.activeepi ? "Ativo" : "Inativo"}
                                </span>
                            </div>
                            </div>
                        </div>

                        {/* Linha 5: Empresa vinculada: 
                        
                        <div className="row mb-4">
                            <div className="col-md-6 mb-3">
                            <label htmlFor="submasterCompanyIdCreate" className="form-label">Empresa</label>
                            <div className="input-group">
                                <span className="input-group-text bg-white">
                                <i className="bi bi-building-fill text-primary"></i>
                                </span>
                                <select
                                id="submasterCompanyIdCreate"
                                name="submasterCompanyId"
                                className="form-select"
                                value={selectedCompanyId || ""}
                                onChange={handleCompanyChange}
                                >
                                <option value="">Empresa padrão - {getDefaultCompanyName()}</option>
                                {companies.map((company) => (
                                    <option key={company.id} value={company.id}>
                                    {company.name}
                                    </option>
                                ))}
                                </select>
                            </div>
                            </div>
                        </div>
                        
                        */}


                        </div>
                    </form>
                    </div>

                    {/* Footer */}
                    <div className="modal-footer epi-modal__footer">
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowFormCreateEmployess(false)}
                    >
                        Fechar
                    </button>
                    <button
                        className="btn btn-outline-primary "
                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                        onClick={handleSubmit}
                    >
                        <i className="bi bi-check-circle me-2"></i> Salvar
                    </button>
                    </div>
                </div>
                </div>
            </div>
        )}

        {minimumStockConfirmationAction && typeof document !== "undefined" && createPortal(
            <>
                <div
                    className="modal-backdrop fade show"
                    style={{ zIndex: 1000000 }}
                />
                <div
                    className="modal fade show d-block"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="minimumStockConfirmationTitle"
                    style={{ zIndex: 1000001 }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content shadow-lg rounded-3">
                            <div
                                className="modal-header"
                                style={{ backgroundColor: "#fff3cd" }}
                            >
                                <h5
                                    id="minimumStockConfirmationTitle"
                                    className="modal-title"
                                >
                                    <i className="bi bi-exclamation-triangle-fill text-warning me-2" />
                                    Confirmar quantidade mínima
                                </h5>
                            </div>
                            <div className="modal-body">
                                <p className="mb-0">
                                    Quantidade mínima é maior que quantidade atual, deseja prosseguir?
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleCancelMinimumStockConfirmation}
                                    disabled={minimumStockConfirmationLoading}
                                >
                                    Não
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleConfirmMinimumStock}
                                    disabled={minimumStockConfirmationLoading}
                                >
                                    {minimumStockConfirmationLoading && (
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    )}
                                    Sim
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>,
            document.body
        )}



        {/** Modal de Imagem do EPI */}
        {showImageModal && (
    <div className="modal fade show d-block">
        <div className="modal-dialog modal-xl">
        <div className="modal-content shadow-lg rounded-3 epi-modal">

            {/* Cabeçalho */}
            <div
            className="modal-header"
            style={{ background: "linear-gradient(90deg, #0d6efd, #5dade2)", color: "#fff" }}
            >
            <h5 className="modal-title" style={{color:"white"}}>
                <i className="bi bi-images me-2"></i> Visualizar e Adicionar Imagens
            </h5>
            <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setShowImageModal(false)}
            ></button>
            </div>

            {/* Corpo do Modal */}
            <div className="modal-body epi-modal__body">
            <div className="row g-4 justify-content-center">
                {modalImages.map((img, index) => (
                <div key={img.id} className="col-md-4 col-sm-6">
                    <div
                    className="border rounded-4 shadow-sm p-2 text-center bg-light position-relative epi-image-card"
                    style={{ transition: "transform 0.2s", cursor: "pointer" }}
                    title="Clique para ampliar"
                    >
                    <img
                        src={img.url}
                        alt={`EPI-${index}`}
                        className="img-fluid rounded"
                        style={{ maxHeight: "180px", objectFit: "contain" }}
                    />
                    {canEpiEdit && !canDeleteImg && (
                        <button
                        type="button"
                        onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            void handleDeleteImg(img.id);
                        }}
                        disabled={deletingModalImageId === img.id}
                        className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 shadow-sm"
                        title="Remover imagem"
                        style={{ zIndex: 2 }}
                        >
                        <i className={`bi ${deletingModalImageId === img.id ? "bi-hourglass-split" : "bi-x-lg"}`}></i>
                        </button>
                    )}
                    </div>
                </div>
                ))}
            </div>
            </div>

            {/* Upload de Imagem */}
            <div className="modal-footer d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 epi-modal__footer">
            <label
                htmlFor="imagemEpi"
                className="btn btn-outline-primary d-flex align-items-center gap-2 mb-0"
            >
                <i className="bi bi-upload"></i> Selecionar Imagem
            </label>
            <input
                type="file"
                id="imagemEpi"
                name="imagemEpi"
                className="d-none"
                onChange={handleChangeImage}
                multiple
                accept="image/*"
                ref={fileInputRef}
            />
            </div>

            {/* Botões */}
            <div className="modal-footer epi-modal__footer">
            <button
                className="btn btn-secondary"
                onClick={() => setShowImageModal(false)}
            >
                <i className="bi bi-x-circle me-1"></i> Fechar
            </button>
            <button
                className="btn btn-outline-primary"
            
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                onClick={() => handleSubmitImage(String(idEpi))}
            >
                <i className="bi bi-plus-circle me-1"></i> Adicionar Imagem
            </button>
            </div>

        </div>
        </div>
    </div>
        )}



    </LayoutSubmaster>)
}


export default ConfigSubmasterEpiPage
